import { TaggedImage, TaggedImageResult } from "constructs/TaggedImage";
import { ProjectResult } from "./typing";

export function transformProjectResult(result: ProjectResult) {
  let project: ProjectResult;
  let images: Array<TaggedImage> | undefined;
  

  if (result.images) {
    images = result.images.map((image: TaggedImageResult, index: number) => ({
      ...image,
      obfuscations: image.obfuscations ? JSON.parse(image.obfuscations) : undefined,
    }) ?? undefined);


  }
  
  project =  { ...result, images };

  return project;

}

